import { DialogTitle,DialogActions,DialogContent,Button  } from '@mui/material';
import "./InformationDialog.scss";


interface InformationDialogProps {
    title?: string;
    information: string;
    setInformationDialog: (value: boolean) => void;
  }

function InformationDialog({setInformationDialog,title,information}:InformationDialogProps) {

  return (
    <div className="confirmationDialog">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
          <p dangerouslySetInnerHTML={{ __html: information }}>
          </p>
        
          <DialogActions
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0rem",
              }}
            >
            
              <Button style={{fontSize:'0.9rem',padding:'5px 15px', textTransform:'capitalize'}}
              onClick={()=>{setInformationDialog(false)}}
              >{`Done`}</Button>
            </DialogActions>
        </DialogContent>
  
    </div>
  );
}

export default InformationDialog;